export const validation = {
  client: {
    emails: {
      eachTypeSelected: 'Duid minstens één e-mailadres aan voor elk type e-mail',
      noEmptySelection: 'Selecteer minstens één type e-mail per e-mailadres',
    },
  },
  dateFuture: 'De datum mag niet in het verleden liggen.',
  dateSameOrAfter: '{{attribute}} moet op of na {{after}} zijn.',
  dateTomorrow: 'De vervaldatum moet minstens morgen zijn.',
  email: {
    invalid: 'Vul een geldig e-mailadres in.',
  },
  iban: 'Vul een geldig IBAN nummer in.',
  invoice: {
    lines: {
      minimumOne: 'Voeg tenminste één factuurlijn toe aan de factuur.',
      minimumOneNotFree: 'Voeg tenminste één factuurlijn toe die niet gratis is.',
    },
  },
  invoiceTemplate: {
    nextInvoiceTomorrow: 'De volgende factuur moet ten vroegste morgen zijn.',
  },
  max: '{{attribute}} mag niet groter zijn dan {{max}}.',
  maxDiscount: 'Korting mag niet groter zijn dan de totale prijs.',
  maxFileSize: 'Het bestand mag niet groter zijn dan {{max}} MB.',
  maxLength: '{{attribute}} mag niet groter zijn dan {{max}} karakters.',
  maxLengthInLanguage: '{{attribute}} mag niet groter zijn dan {{max}} karakters ({{lang}}).',
  min: '{{attribute}} mag niet kleiner zijn dan {{min}}.',
  minLength: '{{attribute}} moet groter zijn dan {{min}} karakters.',
  password: {
    incorrect: 'Dit wachtwoord is niet correct.',
    match: 'Dit wachtwoord moet exact hetzelfde zijn als het nieuwe wachtwoord.',
  },
  phoneNumber: {
    format: 'Vul een geldig telefoonnummer in.',
    missingCallingCode: 'Telefoonnummer moet starten met een landcode (bv. +32 in België).',
  },
  quotation: {
    lines: {
      minimumOne: 'Voeg minstens één offertelijn toe aan de offerte.',
      minimumOneNotFree: 'Voeg minstens één offertelijn toe die niet gratis is.',
    },
  },
  required: 'Dit veld is verplicht.',
  requiredAttribute: '{{attribute}} is verplicht.',
  requiredInLanguage: 'Dit veld is verplicht ({{lang}}).',
  vatNumber: {
    belgianFormat: 'Geef je een geldig ondernemingsnummer in? Deze bestaat uit 10 cijfers en start met 0 of 1.',
    inactive: 'Deze organisatie is niet actief.',
    invalid: 'Het btw-nummer is ongeldig, vraag je het nog eens op?',
    unique:
      'Je hebt al een klant aangemaakt met dit btw-nummer. <0>Klik hier</0> om een nieuwe contactpersoon toe te voegen, aan deze klant.',
  },
};
